module.exports = __webpack_public_path__ + "media/images/country_flags/mp-f47cc054d0168592b4402efe2a19ba3e.png";